module.exports = __webpack_public_path__ + "img/77.0a239dda.jpg";